import firebase from "firebase/app";
import useSWR from "swr";

import type { Event } from "@spwn/types/firebase/firestore";

type SalesDashboardEvent = {
  eventId: string;
  eventName: string;
};

const GetSalesDashboardEventsKey = "getSalesDashboardEvents";

export const useGetSalesDashboardEvents = (eventIds: string[]) => {
  const currentUserId = firebase.auth().currentUser?.uid ?? null;
  const uniqueEventIds = Array.from(new Set(eventIds)).sort();
  const uniqueEventIdsKey = JSON.stringify(uniqueEventIds);

  const {
    data: events = [],
    isLoading,
    isValidating,
    error,
    mutate,
  } = useSWR<SalesDashboardEvent[], Error>(
    currentUserId && uniqueEventIds.length > 0
      ? [GetSalesDashboardEventsKey, currentUserId, uniqueEventIdsKey]
      : null,
    async () => {
      const snapshots = await Promise.all(
        uniqueEventIds.map(async (eventId) => {
          return firebase.firestore().collection("events").doc(eventId).get();
        })
      );

      return snapshots.flatMap((snapshot) => {
        if (!snapshot.exists) {
          return [];
        }

        const event = snapshot.data() as Event | undefined;
        if (!event?.title) {
          return [];
        }

        return [
          {
            eventId: snapshot.id,
            eventName: event.title.replace(/<(\/|)br ?(\/|)>/g, "\n"),
          },
        ];
      });
    }
  );

  return {
    events,
    eventNames: events.map((event) => event.eventName),
    isLoading,
    isValidating,
    error,
    mutate,
  };
};
